import { render, staticRenderFns } from "./LaboratoriesModuleComponent.vue?vue&type=template&id=7229bbd2&scoped=true&"
import script from "./LaboratoriesModuleComponent.vue?vue&type=script&lang=js&"
export * from "./LaboratoriesModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoriesModuleComponent.vue?vue&type=style&index=0&id=7229bbd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229bbd2",
  null
  
)

export default component.exports